import TextField from "@material-ui/core/TextField";
import DateRangePicker from "react-bootstrap-daterangepicker";
import React, { useState, useEffect } from "react";
import Popover from "@mui/material/Popover";
import Dialog from '@material-ui/core/Dialog';
// you will need the css that comes with bootstrap@3. if you are using
// a tool like webpack, you can do the following:
// import 'bootstrap/dist/css/bootstrap.css';
// you will also need the css that comes with bootstrap-daterangepicker
import "bootstrap-daterangepicker/daterangepicker.css";
import { DateRange, ArrowLeft, ArrowRight } from "@material-ui/icons";
import { MuiPickersUtilsProvider, DatePicker } from "@material-ui/pickers";
import { makeStyles } from "@material-ui/core/styles";
import DateFnsUtils from "@date-io/date-fns";
import Calendar from './Calendar'
import "./index.css";
import Hidden from '@material-ui/core/Hidden';
import moment from "moment";
import { useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import './journeyDate.css';

const useStyles = makeStyles((theme) => ({
  input: {
    color: "#333333",
    cssUnderline: {
      "&:after": {
        borderBottomColor: "#333333",
      },
    },
    cssLabel: {
      "&$cssFocused": {
        color: "#333333",
      },
    },
  },
  textField: {
    fontSize: '1rem',
    fontWeight: 400
  },
  datePicker: {
    '& .MuiPickersModal-dialog': {
      backgroundColor: 'var(--dark) !important'
    },
    '& .MuiDialogActions-spacing ': {
      backgroundColor: 'var(--darker) !important'
    },
    '& .MuiDialogActions-spacing .MuiButton-label': {
      color: 'var(--darker)'
    },
    '& .MuiTypography-root.MuiPickersYear-root.MuiTypography-subtitle1': {
      color: 'var(--darker)'
    },
    '& .MuiTypography-root.MuiPickersYear-root.MuiPickersYear-yearSelected.MuiTypography-h5.MuiTypography-colorPrimary': {
      color: 'var(--green)'
    },

    '& .MuiPickersModal-dialog .MuiPickersBasePicker-container .MuiToolbar-root': {
      backgroundColor: 'var(--darker)  !important'
    },
    '& .MuiToolbar-root.MuiToolbar-regular.MuiPickersToolbar-toolbar.MuiPickersDatePickerRoot-toolbar.MuiToolbar-gutters': {
      backgroundColor: 'var(--green)  !important'
    },
    '& .MuiPickersBasePicker-container .MuiPickersBasePicker-pickerView .MuiPickersDay-day ': {
      color: 'var(--darker)'
    },
    '& .MuiPickersBasePicker-container .MuiButtonBase-root.MuiIconButton-root.MuiPickersDay-day.MuiPickersDay-dayDisabled ': {
      color: 'var(--backgroundcolor)'
    },

    '& .MuiPickersBasePicker-container .MuiPickersCalendarHeader-iconButton ': {
      color: 'var(--darker)',
      backgroundColor: 'var(--white)',
      padding: '7px',
      margin: '0px 5px'
    }
    ,
    '& .MuiPickersBasePicker-container .MuiPickersDay-daySelected': {

      backgroundColor: 'var(--green)',

    }
    ,
    '& .MuiPickersCalendarHeader-switchHeader p,.MuiTypography-root.MuiPickersCalendarHeader-dayLabel.MuiTypography-caption': {
      color: 'var(--darker) '

    }
  }
}));

export default function BasicDateRangePicker(props) {
  const [showEndDate, setShowEndDate] = useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const handleStartChange = (val) => {
    if (props.onStartChange) props.onStartChange(val);
  };
  const handleEndChange = (val) => {
    if (props.onEndChange) props.onEndChange(val);
  };
  useEffect(() => {
    setShowEndDate(props.journeyType == "Return");
  }, [props.journeyType]);

  let value = props.value;

  return (
    <div className="simpleDateBox">
      {showEndDate ? (
        <div className="simpleDateFlex">
          <input
                type="text"
            className="simpleDateInput"
                placeholder="Departure"
            aria-label="Departure Date"
            tabIndex={0}
            value={value.start ? moment(value.start).format("DD/MM/YYYY") : ""}
            onClick={handleClick}
            readOnly
          />
          <div className="simpleDateDivider" />
          <input
                type="text"
            className="simpleDateInput"
                placeholder="Return"
            aria-label="Return Date"
            tabIndex={0}
                value={value.end ? moment(value.end).format("DD/MM/YYYY") : ""}
            onClick={handleClick}
            readOnly
          />
        </div>
      ) : (
        <input
                    type="text"
          className="simpleDateInput"
                    placeholder="Start Date"
          aria-label="Start Date"
          tabIndex={0}
          value={value.start ? moment(value.start).format("DD/MM/YYYY") : ""}
          onClick={handleClick}
          readOnly
        />
      )}
      {(!fullScreen || !showEndDate) &&
        <Popover
          id={id}
          open={open}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        >
          <div style={{ backgroundColor: 'var(--backgroundcolor)', borderRadius: '5px', height: '100%', width: '100%' }}>
            <Calendar onChange={(data) => {
              if (showEndDate && Array.isArray(data)) {
                handleStartChange(data[0]);
                handleEndChange(data[1]);
              } else {
                handleStartChange(data);
              }
              handleClose();
            }}
              value={showEndDate ? [value.start, value.end] : value.start && value.start}
              showTwoMonths={showEndDate} showRange={showEndDate} query={props.query} />
          </div>
        </Popover>
      }
      {fullScreen && showEndDate && 
        <Dialog fullScreen open={open} onClose={handleClose} >
          <div style={{ backgroundColor: 'var(--backgroundcolor)', borderRadius: '5px', height: '100%', width: '100%' }}>
            <Calendar onChange={(data) => {
              if (showEndDate && Array.isArray(data)) {
                handleStartChange(data[0]);
                handleEndChange(data[1]);
              } else {
                handleStartChange(data);
              }
              handleClose();
            }}
              value={showEndDate ? [value.start, value.end] : value.start && value.start}
              showTwoMonths={showEndDate} showRange={showEndDate} query={props.query} />
          </div>
        </Dialog>
      }
    </div>
  );
}
